var Misc = {
  fillInnerRectToMatchOuterRect : function ( innerRect, outerRect ) {
    // compares the width x height ratios of 2 rectangles
    var incFactor, output = {};

    innerRect.ratio = innerRect.width / innerRect.height;
    outerRect.ratio = outerRect.width / outerRect.height;

    // - IF OUTER RECT HAS WIDER RATIO THAN INNER RECT
    if ( outerRect.ratio > innerRect.ratio ) {
      // - GET HEIGHT INCREASE FACTOR
      incFactor = outerRect.height / innerRect.height;
    }
    // - ELSE THE INNER IS EITHER THE SAME OR A TALLER RATIO, REGARDLESS WE CAN GET OUR INCREASE FACTOR FROM THE WIDTH
    else {
      // - GET WIDTH INCREASE FACTOR
      incFactor = outerRect.width / innerRect.width;
    }

    // - SCALE HEIGHT AND WIDTH OF INNER BY INC FACTOR
    innerRect.newWidth = innerRect.width * incFactor;
    innerRect.newHeight = innerRect.height * incFactor;

    output.incFactor = incFactor;
    output.innerRect = innerRect;
    output.outerRect = outerRect;

    return output;
  },

  requestFullScreen : function (element) {
    // Supports most browsers and their versions.
    var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;

    if (requestMethod) { // Native full screen.
      requestMethod.call(element);
    }
    else if (typeof window.ActiveXObject !== "undefined") { // Older IE.
      var wscript = new ActiveXObject("WScript.Shell");
      if (wscript !== null) {
        wscript.SendKeys("{F11}");
      }
    }
  },

  exitFullScreen : function() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  },

};
